export const initialOrdersFilters = {
  fromDate: '',
  toDate: '',
  selectedFormat: {},
  submit: false,
  isScheduled: false,
  id:''
};
